import { useSessionData } from '@confluence/session-data';

export const useIsPageEligibleForAdminAnnouncementBanner = () => {
	const { edition } = useSessionData();
	return edition === 'PREMIUM' || edition === 'STANDARD';
};
